<template>
    <div>
        <b-alert :show="dismissCountDown" dismissible :variant="type" @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <div v-html="message"></div>
        </b-alert>
        <b-alert v-model="showDismissibleAlert" :variant="type" dismissible>
            <div v-html="message"></div>
        </b-alert>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dismissCountDown: 0,
            message: '',
            type: 'success',
            showDismissibleAlert: false
        }
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        showAlert(sec, s_msg, s_type, mode = '') {
            if (mode == '') {
                this.dismissCountDown = sec;
                this.type = s_type;
                this.message = s_msg;
            }
            else if (mode == '2') {
                this.type = s_type;
                this.message = s_msg;
                this.showDismissibleAlert = true;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MyModule/alert.vue